import { useState, useEffect, useCallback } from 'react';

export const useColumnMenu = ({
  onApplySort,
  onApplyFilter,
  onHideColumn,
  onPinColumn,
}) => {
  const [openMenuColumnId, setOpenMenuColumnId] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const handleToggleMenu = useCallback((event, columnId) => {

    if (openMenuColumnId === columnId) {
      setOpenMenuColumnId(null);
    } else {
      const buttonElement = event.currentTarget; // This should be the filter button element
      if (buttonElement && typeof buttonElement.getBoundingClientRect === 'function') {
        const rect = buttonElement.getBoundingClientRect();
        setMenuPosition({
          top: rect.top,
          left: rect.left + window.scrollX,
        });
        setOpenMenuColumnId(columnId);
      } else {
      }
    }
  }, [openMenuColumnId]); // openMenuColumnId is the only dependency needed for the logic within

  const closeMenu = useCallback(() => {
    setOpenMenuColumnId(null);
  }, []);

  useEffect(() => {
  }, [openMenuColumnId]);


  // Click outside to close logic (ensure .filter-button and .column-menu-dropdown-container classes are correct)
  useEffect(() => {
    if (!openMenuColumnId) return;

    const handleClickOutside = (event) => {
      // If the click is on any filter button, let handleToggleMenu manage it.
      if (event.target.closest('.filter-button')) {
        
        return;
      }
      
      // If the click is outside the dropdown container, close the menu.
      if (!event.target.closest('.column-menu-dropdown-container')) {
        
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenuColumnId, closeMenu]);

  const menuActionHandlers = {
    onSort: useCallback(
      (sortObject) => {
        if (typeof onApplySort === 'function') onApplySort(sortObject);
        closeMenu();
      },
      [onApplySort, closeMenu]
    ),
    onFilter: useCallback(
      (values, filterColumnId) => {
        if (typeof onApplyFilter === 'function') onApplyFilter(values, openMenuColumnId || filterColumnId);
        closeMenu(); 
      },
      [onApplyFilter, closeMenu, openMenuColumnId]
    ),
    onHide: useCallback(
      (hideColumnId) => { // Renamed
        if (typeof onHideColumn === 'function') onHideColumn(openMenuColumnId || hideColumnId);
        closeMenu();
      },
      [onHideColumn, closeMenu, openMenuColumnId]
    ),
    onPin: useCallback(
      (pinColumnId, pinState) => { // Renamed
        if (typeof onPinColumn === 'function') onPinColumn(openMenuColumnId || pinColumnId, pinState);
        closeMenu();
      },
      [onPinColumn, closeMenu, openMenuColumnId]
    ),
  };

  return {
    openMenuColumnId,
    menuPosition,
    handleToggleMenu,
    closeMenu,
    menuActionHandlers,
  };
};